//https://ng-bootstrap.github.io/#/components/toast/examples
import { Component } from '@angular/core';

import { DialogService } from '../Services/DialogService';

@Component({
	selector: 'app-toasts',
	template: `
		<ngb-toast
			*ngFor="let toast of toastService.toasts"
			[class]="toast.classname"
			[autohide]="true"
			[delay]="toast.delay || 5000"
			(hidden)="toastService.removeToast(toast)"
		>
			<ng-template [ngIf]="needsButton(toast)" [ngIfElse]="text">
				<button type="button" class="btn btn-text" (click)="click(toast)">

{{ toast.text }}
</button>
			</ng-template>

			<ng-template #text>{{ toast.text }}</ng-template>
		</ngb-toast>
	`,
	host: { class: 'toast-container position-fixed top-0 end-0 p-3', style: 'z-index: 1200' },
})
export class ToastsContainer {
	constructor(public toastService: DialogService) { }

	needsButton(toast:any): boolean {
		return toast?.onclick;
	}

	click(toast: any) {
		if (toast.onclick) {
			toast.onclick.call();
		}
	}
}
